var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-card"},[_c('div',{ref:"targetChart",staticStyle:{"height":"430px","width":"100%","margin-top":"10px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }